import { ArrowUp, ExternalLink } from "lucide-react";
import { LogoMark } from "./Logo";

const platformLinks = [
  { name: "رواج الذكية — التسويق بالذكاء الاصطناعي", url: "https://www.rawajsmart.com", display: "rawajsmart.com" },
  { name: "برولانسر — منصة العمل الحر السعودية", url: "https://www.prolancer.sa", display: "prolancer.sa" },
  { name: "حاسبتنا الذكية — تسعير خدمات العمل الحر", url: "https://www.prolancer.app", display: "prolancer.app" },
];

export const Footer = () => (
  <footer className="relative border-t border-[#D4AF37]/15 bg-[#060B19] py-12" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <LogoMark size={44} />
            <div>
              <div className="font-display font-extrabold text-lg text-[#F8FAFC]">براح الرقمية</div>
              <div className="font-body text-xs text-[#94A3B8]">للاتصالات وتقنية المعلومات</div>
            </div>
          </div>
          <p className="mt-5 font-body text-sm leading-relaxed text-[#94A3B8] max-w-sm">
            مكتب سعودي يبني ويدير منصات رقمية حيّة مدعومة بالذكاء الاصطناعي — من الفكرة إلى الإطلاق والتشغيل.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="font-display font-bold text-[#E5C158] mb-4">روابط سريعة</div>
          <ul className="space-y-2.5 font-body text-sm text-[#94A3B8]">
            {[
              ["#about", "من نحن"],
              ["#services", "خدماتنا"],
              ["#platforms", "منصاتنا"],
              ["#methodology", "منهجيتنا"],
              ["#contact", "تواصل معنا"],
            ].map(([href, label]) => (
              <li key={href}>
                <a
                  href={href}
                  data-testid={`footer-link-${href.slice(1)}`}
                  onClick={(e) => {
                    e.preventDefault();
                    const el = document.querySelector(href);
                    if (!el) return;
                    if (window.__lenis) {
                      window.__lenis.scrollTo(el, { offset: -80, duration: 1.2 });
                    } else {
                      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: "smooth" });
                    }
                  }}
                  className="hover:text-[#E5C158] transition-colors duration-300"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-5">
          <div className="font-display font-bold text-[#E5C158] mb-4">منصاتنا الحيّة</div>
          <ul className="space-y-3">
            {platformLinks.map((p) => (
              <li key={p.domain}>
                <a
                  href={p.url}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`footer-platform-${p.display.replace(/\./g, "-")}`}
                  className="group flex items-center justify-between gap-3 rounded-2xl border border-[#D4AF37]/15 bg-[#0F1A36]/40 px-4 py-3 hover:border-[#D4AF37]/40 hover:bg-[#0F1A36]/70 transition-all duration-300"
                >
                  <div>
                    <div className="font-body text-sm font-bold text-[#F8FAFC]">{p.name}</div>
                    <div className="font-mono-tech text-xs text-[#94A3B8] mt-0.5" dir="ltr">{p.display}</div>
                  </div>
                  <ExternalLink size={16} className="text-[#D4AF37] shrink-0 group-hover:translate-x-[-2px] group-hover:translate-y-[-2px] transition-transform" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-[#D4AF37]/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="font-body text-xs text-[#64748B] text-center sm:text-right" data-testid="footer-copyright">
          © {new Date().getFullYear()} مكتب براح الرقمية للاتصالات وتقنية المعلومات
          <span className="mx-2 text-[#D4AF37]/50">•</span>
          س.ت <span className="font-mono-tech" dir="ltr">7054088864</span>
          <span className="mx-2 text-[#D4AF37]/50">•</span>
          جميع الحقوق محفوظة
        </div>
        <div className="flex items-center gap-4">
          <a
            href="/barah-inquiries"
            data-testid="footer-admin-link"
            aria-label="لوحة الإدارة"
            title="لوحة الإدارة"
            className="opacity-60 hover:opacity-100 transition-opacity duration-300"
          >
            <svg width="26" height="18" viewBox="0 0 26 18" data-testid="footer-saudi-flag-icon">
              <rect width="26" height="18" rx="2" fill="#006C35" />
              <rect x="5" y="5" width="16" height="1.6" rx="0.8" fill="#fff" opacity="0.9" />
              <rect x="8" y="8.5" width="10" height="1.4" rx="0.7" fill="#fff" opacity="0.9" />
              <rect x="6" y="12" width="14" height="1.4" rx="0.7" fill="#fff" opacity="0.85" />
            </svg>
          </a>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid="footer-back-to-top"
            className="inline-flex items-center gap-2 text-xs text-[#D4AF37] hover:text-[#E5C158] transition-colors"
            aria-label="العودة للأعلى"
          >
            العودة للأعلى <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </div>
  </footer>
);
